import type { MetadataMappingState } from '../../../../../reducers/metadataMappingReducer';

/**
 * Filters process mining states for localStorage persistence.
 * Only loading states need to survive page refresh.
 */
export const metadataMappingPersistedStateHandler = (
  metadataMappingState: MetadataMappingState,
) => ({
  funnelMaps: Object.fromEntries(
    Object.entries(metadataMappingState.funnelMaps).filter(
      ([, funnelState]) => funnelState.status === 'loading',
    ),
  ),
});
